module.exports = "<div style=\"position:relative;top:80px;margin-left:auto;margin-right:auto;width:1200px;\">\n    <app-places></app-places>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/sofos/projects/anadigit/kounoupia-data-entry/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main